function isEmptyValue(value) {
    return (
        value === undefined ||
        value === null ||
        (typeof value === 'number' && isNaN(value)) ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim().length === 0)
    )
}

function extractVParams(routePath) {
    const urlParams = new URLSearchParams(routePath)
    const vParams = []
    for (let i = 1; i <= 9; i++) {
        const vParam = urlParams.get('v' + i)
        if (vParam !== null) {
            vParams.push(vParam)
        }
    }
    return vParams
}

export { isEmptyValue, extractVParams }
